import { SET_BENUTZER, SET_BENUTZER_NAME, SAVE_SETTINGS, SET_LANGUAGE, SET_PRIVILEGED_USER, SET_PRIVILEGED_USER_MENU } from './types';
import dbSettings from '../db/DbSettings';

export const SaveSettings = (settings) => async(dispatch) => {

    let savedSettings = await(new dbSettings()).SaveSettings(settings);
    dispatch({
        type: SAVE_SETTINGS,
        settings: savedSettings
    });
}

export const SetBenutzer = (new_benutzer) => {
  return {
      type: SET_BENUTZER,
      payload: new_benutzer
  };
}

export const SetBenutzerName = (new_benutzer_name) => {
  return {
      type: SET_BENUTZER_NAME,
      payload: new_benutzer_name
  };
}

export const SetLanguage = (lang) => {
  return{
    type: SET_LANGUAGE,
    payload: lang
  }
}

export const SetPrivilegedUser = (val) => {
  return {
    type: SET_PRIVILEGED_USER,
    payload: val
  }
}

export const SetPrivilegedUserMenu = (val) => {
  return {
    type: SET_PRIVILEGED_USER_MENU,
    payload: val
  }
}